import NewBusinessIcon from '@/assets/images/onboarding/New_business.svg'
import ImproveCashflowIcon from '@/assets/images/onboarding/Improve_cashflow.svg'
import GrowBusinessIcon from '@/assets/images/onboarding/Grow_business.svg'
import { TITLES, journeyDestinations } from '@/utils/constants'

// funding reason forms
export const fundingReasonFormOne = {
  title: TITLES.FUNDING_REASON_FORM_ONE,
  fields: [
    {
      dataType: 'string',
      label: '',
      type: 'radio',
      name: 'funding-reason-one',
      options: [],
      errorMessages: {
        error: 'Something went wrong. Please try again.',
        required: 'You need to make a selection before continuing. Please select an option.'
      },
      rules: { required: true }
    }
  ]
}

export const fundingReasonFormSecureFunds = {
  title: TITLES.FUNDING_REASON_FORM_SECURE_FUNDS,
  description: "We'll ask you a few questions to help find the best funding options for you. Don't worry, your credit score won't be affected.",
  fields: [
    {
      dataType: 'string',
      label: '',
      type: 'radio',
      name: 'funding-reason-secure-funds',
      options: []
    }
  ]
}

export const fundingReasonFormNotSure = {
  title: TITLES.FUNDING_REASON_FORM_NOT_SURE,
  fields: [
    {
      dataType: 'string',
      label: '',
      type: 'radio',
      name: 'funding-reason-not-sure',
      options: []
    }
  ]
}

export const refinanceDebt = {
  title: 'I want to refinance debt',
  description: {
    title: 'This option is for day-to-day cashflow and debt solutions.',
    text: 'We can match you with capital or fixed term loans as well as helping you with a commercial mortgage, grant or a tax advance.'
  },
  category: 'improveCashflowDebt',
  icon: ImproveCashflowIcon
}

export const startNewBusiness = {
  title: "I'm starting a new business",
  description: {
    title: "This is the option to choose if you're starting or acquiring a new business.",
    text: "There's lots of support available; from start up loans and asset finance to help with finding an investor and improving your pitch deck."
  },
  category: 'startNewBusiness',
  icon: NewBusinessIcon
}

export const growMyBusiness = {
  title: 'I want to grow my business',
  description: {
    title: 'Choose this option if you want to expand your business with new stock, staff, property or assets.',
    text: 'We can help you with everything from commercial mortgages and invoice finance to research and development grants.'
  },
  category: 'growMyBusiness',
  icon: GrowBusinessIcon
}

export const improveCashflowDebt = {
  title: 'I want to improve my cashflow',
  description: {
    title: 'This option is for day-to-day cashflow and debt solutions.',
    text: 'We can match you with capital or fixed term loans as well as helping you with a commercial mortgage, grant or a tax advance.'
  },
  category: 'improveCashflowDebt',
  icon: ImproveCashflowIcon
}

const onboardingConfig = {
  steps: ['Enter your details', 'Tell us more about your business', 'See your full funding matches'],
  stagePage: {
    stageGoals: [startNewBusiness, growMyBusiness, improveCashflowDebt],
    finalOption: { text: "I'm not sure yet", category: 'notSure' },
    headerText: 'Already have an account?'
  },
  detailsPage: {
    description: 'We ask these questions so that we can match you with providers in our marketplace.',
    formRedirectOnOtherFundingReason: {
      startNewBusiness: 'startaBusiness',
      growMyBusiness: 'businessExpansion',
      improveCashflowDebt: 'improveCashflow',
      notSure: 'businessExpansion'
    }
  },
  journeyDestinations
}

export default onboardingConfig
